export type Identifiable = {
  id: string;
};

export const dedupeById = <T extends Identifiable>(items: T[]): T[] => {
  const seen = new Set<string>();
  return items.filter((item) => {
    const isSeen = !seen.has(item.id);
    seen.add(item.id);
    return isSeen;
  });
};

/**
 * Produces a map of items keyed by id
 */
export const toMapById = <T extends Identifiable>(
  items: T[],
): Map<string, T> => {
  const map = new Map<string, T>();
  for (const item of items) {
    map.set(item.id, item);
  }
  return map;
};

/**
 * Set or append entries keyed by id
 * @returns a copy
 */
export const updateMapById = <T extends Identifiable>(
  map: Map<string, T>,
  items: T[],
): Map<string, T> => {
  const copy = new Map(map);
  for (const item of items) {
    copy.set(item.id, item);
  }
  return copy;
};
